<template>
    <b-container class="container-panel">
        <AmbitLogo></AmbitLogo>
        <LanguageSelection></LanguageSelection>
        <QuickPayForm v-show="!customer.confirmed" ></QuickPayForm>
        <QuickPayConfirm v-if="customer.confirmed"></QuickPayConfirm>
    </b-container>
</template>

<script>
import AmbitLogo from '../components/AmbitLogo.vue';
import QuickPayForm from '../components/QuickPayForm.vue';
import QuickPayConfirm from '../components/QuickPayConfirm.vue';
import LanguageSelection from '../components/LanguageSelection.vue';
import { mapGetters } from 'vuex';


export default {
        name: "QuickPay",
        components: {
            AmbitLogo,
            QuickPayForm,
            QuickPayConfirm,
            LanguageSelection
        },
        mounted() {
            this.$store.dispatch('shell/updateLanguageFromQuery', this.$route.query.lang);
        },
        computed: {
            ...mapGetters({
                customer: 'lobby/quickPayCustomer'
                })
            }
};
</script>
